import React from 'react';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title = "Confirmación", message = "¿Estás seguro que deseas finalizar este proceso? Los cambios no guardados se perderán." }) => {
    if (!isOpen) return null;

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 10500, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ width: '90%', maxWidth: '450px', backgroundColor: '#fff', borderRadius: '10px', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 30px rgba(0,0,0,0.5)', overflow: 'hidden' }}>
                <div style={{ padding: '15px 20px', backgroundColor: '#dc3545', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h5 style={{ margin: 0, fontWeight: 'bold' }}>
                        <i className="bi bi-exclamation-triangle-fill me-2"></i> {title}
                    </h5>
                    <button type="button" onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '1.5rem', lineHeight: 1, padding: 0, cursor: 'pointer' }}>&times;</button>
                </div>
                
                <div style={{ padding: '25px 20px', backgroundColor: '#f8f9fa', textAlign: 'center' }}>
                    <p style={{ fontSize: '1.1rem', margin: 0, color: '#333' }}>{message}</p>
                </div>
                
                <div style={{ padding: '15px 20px', borderTop: '1px solid #dee2e6', display: 'flex', justifyContent: 'flex-end', gap: '10px', backgroundColor: '#fff' }}>
                    <button type="button" className="btn btn-light border" onClick={onClose}>Retroceder</button>
                    <button type="button" className="btn btn-danger px-4" onClick={onConfirm}>Aceptar</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
